import localeContext from './LocaleContext';
import { formatReactTemplate } from '../formatter/formatReactTemplate';
import enUS from './en_US';
export function $l(component, key, injectionOptions) {
    const locale = localeContext.get(component, key, enUS);
    if (injectionOptions) {
        return formatReactTemplate(locale, injectionOptions);
    }
    return locale;
}
export default localeContext;
